export const demoForm =
  "https://forms.office.com/Pages/ResponsePage.aspx?id=qjfY1zkcekWz6XUWzxZ2X7QtQAXgGixEsmvvze2zb0ZUNTg4OUFOM0NOTDRPMlNYWjBLRzVJUU5KUC4u "
